var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resizeMap),expression:"resizeMap"}],staticClass:"map-container",attrs:{"fill-height":""}},[_c('map-control',{attrs:{"uiid":_vm.uiid}}),_c('mission-map',{ref:"map",attrs:{"uiid":_vm.uiid}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }